import type { IconSvgObject } from './types';

const SaveIcon: IconSvgObject = [
  ["path", { d: "M3 19V5C3 3.89543 3.89543 3 5 3H17.1716C17.702 3 18.2107 3.21071 18.5858 3.58579L20.4142 5.41421C20.7893 5.78929 21 6.29799 21 6.82843V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 3V6.5C17 7.32843 16.3284 8 15.5 8H8.5C7.67157 8 7 7.32843 7 6.5V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 21V14.5C17 13.6716 16.3284 13 15.5 13H8.5C7.67157 13 7 13.6716 7 14.5V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SaveIcon;
